import { memo, ReactNode, VFC } from 'react';
import { InputElementContainer, DatePickerInputField } from '../atoms';
import { Divider } from '@material-ui/core';
import { disableAll } from 'loglevel';

type Props = {
  text: string;
  date: Date | null;
  onChange: (date: Date | null, value?: string | null | undefined) => void;
  id: string;
  span?: boolean;
  help?: ReactNode;
  emptyLabel?: string | null;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
};

const DateField: VFC<Props> = props => {
  const {
    text,
    date,
    id,
    onChange,
    span = false,
    help,
    emptyLabel,
    minDate,
    maxDate,
    disabled
  } = props;

  return (
    <>
      <InputElementContainer text={text} span={span} help={help}>
        <DatePickerInputField
          date={date}
          onChange={onChange}
          id={id}
          emptyLabel={emptyLabel}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
      </InputElementContainer>
      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
    </>
  );
};

export default memo(DateField);
